import styled from 'styled-components';
import { styles } from '../../../../../consts';

const { white, greenSecondary, fontMontserrat, gray, disabledRow, paymentDescription, secondaryRed } = styles;

interface IProps {
  isSelected: boolean;
  isExpired: boolean;
  preSelected?: boolean;
}

const setCursor = ({ isExpired }: IProps) => (isExpired ? 'not-allowed' : 'pointer');
const setFontColor = ({ isExpired }: IProps) => (isExpired ? gray : 'unset');
const setExpirationDateFrontColor = ({ isExpired }: IProps) => (isExpired ? secondaryRed : paymentDescription);
const setOpacity = ({ isExpired }: IProps) => (isExpired ? 0.5 : 1);
const setBackground = ({ isExpired }: IProps) => (isExpired ? disabledRow : white);
const setBoxShadow = (p: IProps) =>
  p.isSelected ? `0 0.1625rem 0.125rem 0 rgba(0, 0, 0, .22)` : `0 0.1625rem 0.125rem 0 rgba(0, 0, 0, 0.22)`;
const setOutline = ({ isSelected }: IProps) => (isSelected ? `0.125rem solid ${greenSecondary}` : 0);

export const Container = styled.div<IProps>`
  width: 100%;
  display: inline-flex;
  cursor: ${setCursor};
  box-sizing: border-box;
  background-color: ${setBackground};
  box-shadow: ${setBoxShadow};
  outline: ${setOutline};
  margin: 0.175rem 0;
  font-family: ${fontMontserrat};
  font-weight: 400;

  @media (max-width: 768px) {
    margin: 0.2rem 0 0.2rem 0;
  }

  .saved-instrument-row-item__expiration-date {
    color: ${setExpirationDateFrontColor};
  }

  .saved-instrument-row-item__card-number {
    color: ${setFontColor};
  }

  .saved-instrument-row-item__card-details {
    margin-top: 0.725rem;
  }

  .tooltip-content-wrapper {
    @media (min-width: 992px) {
      white-space: nowrap;
      width: 15.125rem;
      height: 1.725rem;
      text-align: center;
      display: table-cell;
      vertical-align: middle;
      font-size: 0.75rem;
    }
  }

  .saved-instrument-row-item__delete-card-button {
    margin-left: auto;
    margin-right: 1.5rem;
  }
`;

const setHeight = ({ height }: { height: number }) => `${height}px`;

export const SpinnerContainer = styled.div<{ height: number }>`
  margin-bottom: 0.35rem;
  height: ${setHeight};
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    margin-bottom: 0.4rem;
  }
`;

export const InlineDiv = styled.div`
  display: inline-block;
  margin: 0.625rem 0.125rem 0.625rem 0;
`;

export const ImageWrapper = styled(InlineDiv)<IProps>`
  width: 4.5rem;
  height: 1.138rem;
  padding: 0.7rem 0 0.7rem 0.5rem;
  transition: border 200ms ease-in-out;
  position: relative;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: ${setOpacity};

  img {
    max-width: 85%;
  }

  @media (max-width: 992px) {
    height: 0.8875rem;
    width: 4rem;
  }
`;

export const CardNumber = styled.div`
  font-size: 0.75rem;
`;

export const CardExpirationDate = styled.div`
  margin-top: 0.325rem;
  font-size: 0.625rem;
`;
